<template>
  <div class="chat">
    <div class="mine messages">
      <div class="message">
        <div>
          Course previews are currently in beta.
        </div>
      </div>
      <div class="message last">
        <div>
          Only the content of the day will be displayed as an incoming message.
          More to come soon!
        </div>
      </div>
    </div>
    <template v-for="(message, index) in getMessages">
      <div
        class="mine messages"
        v-if="message.type == 'mine'"
        :key="message.text"
      >
        <div class="message last">
          <div>
            {{ message.text }}
          </div>
        </div>
      </div>
      <div class="time" v-if="message.type == 'line'" :key="message.text">
        <span>{{ message.text }}</span>
      </div>
      <div
        class="yours messages"
        v-if="message.type == 'image'"
        :key="message.text + index"
      >
        <div class="message image">
          <!-- <v-responsive :aspect-ratio="9 / 9"> -->
          <!-- <v-card-text> -->
          <img :src="generateImage(message.text)" class="image-message" />
          <!-- </v-card-text> -->
          <!-- </v-responsive> -->
        </div>
      </div>
      <div
        class="yours messages"
        v-if="message.type == 'yours'"
        :key="message.text"
      >
        <div class="message last">
          <div>
            {{ message.text }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    messages: {
      type: Array
      // validator: value => {
      //   if (Array.isArray(value) && value.length == 0) {
      //     return true;
      //   }
      //   let good = true;
      //   value.forEach(obj => {
      //     // if (!obj.text || !obj.type) {
      //     //   good = false;
      //     // }
      //     if (["line", "yours", "mine", "image"].includes(obj.type)) {
      //       good = false;
      //     }
      //   });
      //   return good;
      // }
    }
  },
  computed: {
    getMessages() {
      return this.messages;
    }
  },
  methods: {
    generateImage(img) {
      if (img && img != "null") {
        return img;
      } else {
        return this.$store.getters["getOrganization"] &&
          this.$store.getters["getOrganization"].favicon
          ? this.$store.getters["getOrganization"].favicon
          : "https://images.static.arist.co/5d1315c147dda60e60b6d7b1/1567567124904_92496";
      }
    }
  }
};
</script>

<style scoped>
.time {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.137);
  color: rgb(102, 101, 101);
  line-height: 0.1em;
  margin: 10px 0 10px;
}

.time span {
  background: #fff;
  padding: 0 10px;
}
.chat {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  font-size: 12px;
}

.messages {
  display: flex;
  flex-direction: column;
}
@supports (-webkit-appearance: none) {
  .message {
    border-radius: 7px;
  }
}
.message {
  max-width: 90%;
  padding: 8px 15px;
  margin-top: 5px;
  margin-bottom: 5px;
  white-space: pre-line !important;
  overflow-wrap: break-word;
}
.image-message {
  object-fit: contain !important;
  width: 100%;
}
.yours {
  align-items: flex-start;
}

.yours .message {
  margin-right: 10%;
  background-color: #eee;
  position: relative;
}

.yours .message.last:before {
  content: "";
  position: absolute;
  z-index: 0;
  bottom: 0;
  left: -7px;
  height: 20px;
  width: 20px;
  background: #eee;
}
.yours .message.last:after {
  content: "";
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: -10px;
  width: 10px;
  height: 20px;
  background: white;
  border-bottom-right-radius: 10px;
}

.mine {
  align-items: flex-end;
}

.mine .message {
  color: white;
  margin-left: 10%;
  background: linear-gradient(to bottom, #00d0ea 0%, #0085d1 100%);
  background-attachment: fixed;
  position: relative;
}

.mine .message.last:before {
  content: "";
  position: absolute;
  z-index: 0;
  bottom: 0;
  right: -8px;
  height: 20px;
  width: 20px;
  background: linear-gradient(to bottom, #00d0ea 0%, #0085d1 100%);
  background-attachment: fixed;
  border-bottom-left-radius: 15px;
}

.mine .message.last:after {
  content: "";
  position: absolute;
  z-index: 1;
  bottom: 0;
  right: -10px;
  width: 10px;
  height: 20px;
  background: white;
  border-bottom-left-radius: 10px;
}
</style>
